<template>
  <div class="item-main">
    <div
      class="form"
      :style="{
        'flex-direction': !isDesktop && 'column',
        'align-items': !isDesktop && 'start',
      }"
    >
      <DateRangePicker @change="onDateChange"></DateRangePicker>
      <a-button
        type="primary"
        style="margin-left: 10px;"
        :style="{
          width: !isDesktop && '30%',
          'margin-top': !isDesktop && '8px',
          'margin-left': !isDesktop && '0',
        }"
        @click="handleDownload"
        >Download</a-button
      >
    </div>
    <a-spin :spinning="spinning">
      <div
        class="total"
        :style="{
          'flex-direction': !isDesktop && 'column',
          'margin-top': !isDesktop && '12px',
        }"
      >
        <div
          class="total-item"
          :style="{
            'margin-left': !isDesktop && '0px',
          }"
        >
          Total Bonus:
          <span>{{ totalBonus || 0 }}</span>
        </div>
        <div
          class="total-item"
          :style="{
            'margin-left': !isDesktop && '0px',
          }"
        >
          Total Volume:
          <span>{{ totalVolume || 0 }}</span>
        </div>
        <div
          class="total-item"
          :style="{
            'margin-left': !isDesktop && '0px',
            'margin-bottom': !isDesktop && '8px',
          }"
        >
          Total Amount:
          <span>{{ totalAmount || 0 }}</span>
        </div>
      </div>
      <a-table
        :scroll="{ x: !isDesktop ? true : false }"
        :pagination="pagination"
        :columns="tableColumns"
        :data-source="tableData"
        @change="onTableChange"
      ></a-table>
    </a-spin>
  </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker'

const tableColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
  },
  {
    title: 'Registration Date',
    dataIndex: 'registrationDate',
  },
  {
    title: 'Country',
    dataIndex: 'country',
  },
  {
    title: 'Trading Account',
    dataIndex: 'tradingAccount',
    ellipsis: true,
  },
  {
    title: 'Deposit Amount',
    dataIndex: 'depositAmount',
  },
  {
    title: 'Trading Volume',
    dataIndex: 'volume',
  },
  {
    title: 'CPA Bonus',
    dataIndex: 'cPABonus',
  },
]

export default {
  name: 'BonusReport',
  components: { DateRangePicker },
  watch: {
    activityId(val) {
      this.query.activityId = val
      this.getList(1)
    },
  },
  data() {
    return {
      activityId: undefined,
      query: {
        beginTime: undefined,
        endTime: undefined,
        page: 1,
        limit: 10,
      },
      tableData: [],
      totalBonus: undefined,
      totalVolume: undefined,
      totalAmount: undefined,
      pagination: {
        total: 0,
        current: 1,
        showSizeChanger: false,
        pageSize: 10,
        showTotal: (total) => {
          return `Total: ${total}`
        },
      },
      tableColumns,
      spinning: false,
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  methods: {
    getList(page) {
      if (page) this.query.page = page
      this.spinning = !this.spinning
      this.$store
        .dispatch('statistics/GetCPABonusReport', this.query)
        .then((res) => {
          this.tableData = res[0].list
          this.pagination.total = res[0].total
          this.totalAmount = res[1].depositAmount
          this.totalVolume = res[1].tradingVolume
          this.totalBonus = res[1].cPABonus
        })
        .finally(() => {
          this.spinning = !this.spinning
        })
    },
    onDateChange(beginTime, endTime) {
      this.query.beginTime = beginTime
      this.query.endTime = endTime
      this.getList(1)
    },
    onTableChange(pagination) {
      this.pagination = pagination
      this.getList(pagination.current)
    },
    handleDownload() {
      const query = { ...this.query }
      query.page = 1
      query.limit = 100000
      this.$store
        .dispatch('statistics/GetCPABonusReport', query)
        .then((res) => {
          import('@/vendor/Export2Excel').then((excel) => {
            // 表头
            const header = {
              sheet1: [
                'Name',
                'Registration Date',
                'Country',
                'Trading Account',
                'Deposit Amount',
                'Trading Volume',
                'CPA Bonus',
              ],
            }
            const filterVal = [
              'name',
              'registrationDate',
              'country',
              'tradingAccount',
              'depositAmount',
              'volume',
              'cPABonus',
            ]
            const list = res[0].list
            const data = { sheet1: this.formatJson(filterVal, list) }
            excel.export_json_to_excel({
              header,
              data,
              filename: 'Account Details',
              autoWidth: true,
              bookType: 'xlsx',
            })
          })
        })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((row) =>
        filterVal.map((attr) => {
          return row[attr]
        }),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.total {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 20px;
  font-weight: bold;

  .total-item {
    margin: 0 30px;
  }
}
</style>
